import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Radio } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { usePoll } from '../../contexts/PollContext';
import LiveEventsList, { getLiveEventLink } from './LiveEventsList';
import BottomSheet from './BottomSheet';

/** Mobile bottom-sheet twin of the Header "Live Now" dropdown — same list, same data. */
const LiveEventsPanel = ({ isOpen, onClose }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { liveEvents } = usePoll();

  const handleEventClick = (event) => {
    onClose();
    navigate(getLiveEventLink(event));
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-between px-4 pt-3 pb-2">
        <div className="flex items-center gap-2">
          <Radio className="w-5 h-5 text-red-500" />
          <span className={`font-semibold ${theme.text}`}>Live Now</span>
        </div>
        <button onClick={onClose} className={`p-1.5 rounded-lg ${theme.cardHover}`}>
          <X className={`w-4 h-4 ${theme.textMuted}`} />
        </button>
      </div>

      <div className={`h-px ${theme.border} bg-current opacity-10 mx-4`} />

      {liveEvents.length === 0 ? (
        <div className="text-center py-8 px-4">
          <Radio className="w-10 h-10 text-gray-300 mx-auto mb-2" />
          <p className={`text-sm ${theme.textMuted}`}>Nothing live right now</p>
        </div>
      ) : (
        <LiveEventsList liveEvents={liveEvents} onEventClick={handleEventClick} />
      )}
    </BottomSheet>
  );
};

export default LiveEventsPanel;
